/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react';
import AnimatedPageFade from '../../components/Animations/AnimatedPageFade';
import AnimatedImage from '../../components/Animations/AnimatedImage';
import { dataService } from '../../services/data.service';
import ApplicationContext from '../../context/ApplicationContext';
import moment from 'moment-timezone';
import AnimatedButton from '../../components/Button';
import './styles.css';
import { generateDeviceFingerprint } from '../../helpers/CommonFunctions';
import ThreeDotsBlackLoader from '../../components/LoadingDots/ThreeDotsBlack';
import { appointmentLanguageContent } from './appointmentLanguageContent';
import { backNextLanguageContent } from '../../components/Button/backNextLanguageContent';

function Appointments() {
    const { facilityData, handlePage, handleToast, selectedLanguage, tempToken } = useContext(ApplicationContext);
    const [appointments, setAppointments] = useState('');
    const [pageLoading, setPageLoading] = useState(true);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        dataService.getAppointmentDetails(sessionStorage.getItem('session')).then((res) => {
            if(res.error === false) {
                setAppointments(res.data.data);
                setPageLoading(false);
            }
        })
    }, []);

    const handleNavigation = () => {
        setLoading(true);
        const payload = {
            "patient_id": appointments.patient_id,
            "fingerprint_id": generateDeviceFingerprint(),
            "appointment_status": 'Confirmed'
        }
        dataService.changeAppointmentStatus(tempToken, payload).then((res) => {
            setLoading('')
            if(res.error === false) {
                handlePage('identity');
            } else {
                handleToast(res.data.data.message);
            }
        })
    }

    return (
        <AnimatedPageFade className='flex flex-col justify-between relative h-welcome gradient-bg rounded-[16px] overflow-hidden'>
            <div className='p-[8px]'>
                <p className='text-center font-semibold text-[#64A003] text-[24px] border-b border-[#D7D7D7] py-[5px] lg:text-[26px] xl:text-[32px] 2xl:text-[38px] flex justify-center items-center'>
                    <AnimatedImage url="/images/Calendar.svg" alt="calendar" className="mr-[12px]" />
                    <p className={selectedLanguage === 'ar' ? 'dir-rtl' : ''}>{appointmentLanguageContent['appointment'][selectedLanguage]}</p>
                </p>
                {appointmentLanguageContent['appt-1'][selectedLanguage]}
                {pageLoading ?
                    <div className='animate-pulse h-[127px] w-full bg-slate-300 mt-[11px] rounded-lg' />
                    : 
                    <div className='mt-[11px] border-2 border-[#007EB4] rounded-lg flex w-full' data-testid="current_appointment">
                        <div className='bg-[#007EB4] flex flex-col items-center justify-center w-[20%] rounded-l-lg relative -left-[2px]'>
                            <p className='text-[#F2F2F2] text-[32px] font-semibold text-center fold-text'>{moment(appointments.appointment_date).format('DD')}</p>
                            <p className='text-[#F2F2F2] text-[24px] font-semibold text-center fold-text'>{moment(appointments.appointment_date).format('MMM')}</p>
                        </div>
                        <div className='w-[80%] mx-[10px] py-[10px]'>
                            <p className='text-[#007EB4] flex font-semibold text-base items-start fold-normal-text'>
                                <AnimatedImage url="/images/Doctor.svg" alt="doctor" className="mr-[12px]" />
                                {appointments.doctor_name || '---'}
                            </p>
                            <p data-testid="facility_name" className='text-[#333] flex font-semibold text-sm items-start break-all mt-3 fold-normal-text'>
                                <AnimatedImage url="/images/Facility.svg" alt="facility" className="mr-[12px]" />
                                {facilityData.name || '---'}
                            </p>
                            <p className='text-[#333] flex font-semibold text-sm items-start break-all mt-3 fold-normal-text'>
                                <AnimatedImage url="/images/Time.svg" alt="time" className="mr-[12px]" />
                                {`${moment(appointments.appointment_date).tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format('hh:mm A z')}` || '---'}
                            </p>
                            <p className='text-[#333] flex font-semibold text-sm items-start break-all mt-3 fold-normal-text'>
                                <AnimatedImage url="/images/Phone.svg" alt="phone" className="mr-[12px]" />
                                {facilityData.contact_person_phone || '---'}
                            </p>
                        </div>
                    </div>}
                {appointmentLanguageContent['appt-2'][selectedLanguage]}
            </div>
            <div className='flex mb-[24px] justify-between mx-[16px] w-auto fold-gap'>
                <AnimatedButton handleClick={() => handlePage('appointment_options')} 
                    disabled={false} id="options-btn" className={`font-semibold text-gray bg-[#F2F2F2] w-[165px] h-[40px] text-[16px] md:text-[18px] lg:text-[18px] xl:text-[18px] 2xl:text-[18px] justify-start fold-normal-text`}>
                    <img src="/images/Calendar-blue.svg" alt="calendar" className='ml-[1.2em] w-[1.7em] h-[1.7em] mr-[16px] fold-m-10' />
                    {backNextLanguageContent['options'][selectedLanguage]}
                </AnimatedButton>
                <AnimatedButton handleClick={() => handleNavigation()} 
                    disabled={false || loading} id="begin_button" className={`font-semibold text-gray bg-[#F2F2F2] w-[165px] justify-center items-center h-[40px] ${loading ? '' : ' pl-[41px]'} text-[16px] md:text-[18px] lg:text-[18px] xl:text-[18px] 2xl:text-[18px] fold-normal-text`}>
                    {loading ? <ThreeDotsBlackLoader /> : backNextLanguageContent['begin'][selectedLanguage]}
                    {!loading && <img src="/images/next.svg" alt="next" className='ml-[1.2em] w-[1.7em] h-[1.7em]' />}
                </AnimatedButton>
            </div>
        </AnimatedPageFade>
    );
}

export default Appointments;